<template>
    <div class="container" ref="container">
        <div class="list">
            <ul>
                <li class="item" @click="staticClick('/anti-fraud/')" style="color: red;">反诈举报</li>
                <li class="item"><a href="https://wpa1.qq.com/EAq4arcw?_type=wpa&qidian=true">联系我们</a></li>
                <li class="item" @click="staticClick('/xiazai/')">软件下载</li>
                <li class="item" @click="staticClick('/buy/')">套餐购买</li>
                
                <!-- <router-link tag="li" class="item" to="/Download">软件下载</router-link>
                <router-link tag="li" class="item" to="/Buy">套餐购买</router-link> -->
                <!-- <li class="item wechat" @mouseover="handwechat" @mouseout="handwechat" ref="wechat">
                    关注微信公众号
                    <div class="wechatImg" ref="wechatImg">
                        <img src="https://admin.huashengdaili.com/images/download/20.18.9.12.jpg" alt="扫码关注微信公众号">
                    </div>
                </li> -->
            </ul>
        </div>
        <div class="text">
            <p class="tc mt-03">跳转软件仅提供IP服务，用户使用跳转软件从事的任何行为均不代表跳转软件的意志和观点，与跳转软件的立场无关，严禁用户使用跳转软件从事任何违法犯罪行为，产生的相关责任用户自负，对此跳转软件不承担任何法律责任</p>
            <p class="tc mt-03">
                <!-- <span>Copyright © 2017-2018 </span> -->
                <span>Copyright © 2017-2022 广州市小弹壳网络科技有限公司版权所有
                  <!-- <img style="width: 50px;height: 40px;vertical-align: -6px;line-height: 16px;display: inline-block;" src="@/assets/img/footer_company.png" alt="company"> -->
                </span>
                <span></span>
                <!-- <span>粤ICP备17160883号-2</span> -->
            </p>
            <!-- <p class="tc mt-03"><img src="~@/assets/img/beian.png" alt=""> 粤公网安备 44010602004040号   互联网虚拟专用网业务许可证 B1-20182888
            <a style="display:none;" href="https://www.cnzz.com/stat/website.php?web_id=1273281427" target="_blank" title="站长统计">站长统计</a>
            </p> -->
        </div>
    </div>
</template>

<script>
export default {
    name: 'Footer',
    methods: {
        staticClick (url) {
          window.location.href=url
        },
        handwechat (e) {
            var _this = this
            var timer
            if(this.$refs.wechatImg.style.display == "block"){
                this.$refs.wechatImg.style.display = "none"
            }else{
                this.$refs.wechatImg.style.display = "block"
            }
        }
    }
}
</script>

<style lang="stylus" scoped>
    .container
        width  1200px
        margin 0 auto
        color #CCCCCC
        font-size 12px
        height 188px
    .list
        border-bottom 1px solid #444444
    .list ul
        display block
        width 280px
        margin 0 auto
        margin-bottom 32px
        &:after
            content ''
            display block
            height 0px
            clear both
    .list ul li
        float left
        width  auto
        padding 0px 10px
        color #FFFFFF
        cursor pointer
    .list ul li:hover, .list ul li a:hover
        color #21a07d
    .list ul li a{
        color #ffffff
    }
    .wechat
        position relative
    .wechat .wechatImg
        padding 10px
        background #333333;
        position absolute
        width 135px
        height 135px
        top -136px
        right -20px
        display inline-block
        display none
    .wechat .wechatImg img
        width 100%
        height 100%
    // .list ul li:nth-child(1), .list ul li:nth-child(2), .list ul li:nth-child(3)
    //     border-right 2px solid #444444
    @media screen and (max-width: 1200px)
        .container
            width auto
            margin auto
     @media screen and (max-width: 458px)
        >>>.ivu-layout-footer
            padding 24px 30px
        .list
            text-align center
        .list ul
            display inline-block
        .text p:nth-child(1)
            padding 0 .4rem
            letter-spacing 1px
            line-height 15px
        .text p:nth-child(2)
            padding 0 1rem
        .text p:nth-child(3)
            padding 0 .86rem
        .list ul li
            padding 0px 10px
</style>




// WEBPACK FOOTER //
// src/pages/Layout/tuifooter.vue